import Compare from "./Compare.page";

export default Compare;
